<template>
  <div
    class="tab-pane fade active show"
    id="searchControl-content"
    role="tabpanel"
    aria-labelledby="searchControl-tab"
  >
    <div class="container-fluid">
      <form class="row g-3">
        <div class="col-md-2">
          <label for="inputEmail4" class="form-label">風景區</label>
          <select class="form-control" v-model.number="selectScenicAreaId">
            <option value="">請選擇</option>
            <option value="-1">全部</option>
            <option
              v-for="(list, index) in carFlowScenicArea"
              :key="index"
              :value="list.id"
            >
              {{ list.name }}
            </option>
          </select>
        </div>

        <!-- <div class="col-md-2">
          <label for="inputEmail4" class="form-label">車種類型</label>
          <select class="form-control" v-model="selectType">
            <option value="-1">全部</option>
            <option value="compact">小型車</option>
            <option value="1">大型車</option>
            <option value="motorcycle">機車</option>
          </select>
        </div> -->

        <div class="col-md-2">
          <label for="inputEmail4" class="form-label">警戒狀態</label>
          <select class="form-control" v-model="selectstatus">
            <option
              v-for="(list, index) in statusList"
              :key="index"
              :value="list.status"
            >
              {{ list.description }}
            </option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料開始時間</label>
          <datetime
            input-class="form-control"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }"
            :minute-step="1"
            :max-datetime="maxSelectTime"
            :auto="true"
            v-model="startTime"
            @focus="updateMaxSelectTime"
            
          >
          </datetime>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料結束時間</label>
          <datetime
            input-class="form-control"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }"
            :minute-step="1"
            :max-datetime="maxSelectTime"
            :auto="true"
            v-model="endTime"
            @focus="updateMaxSelectTime"
          >
          </datetime>
        </div>

        <div class="col-md-6 d-flex align-items-end">
          <button
            type="button"
            class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1"
            @click="querySearch"
          >
            <i class="fas fa-search"></i> 查詢
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm rounded-pill px-3 mx-1"
            @click="queryCSV"
          >
            <i class="fas fa-share"></i> 匯出
          </button>
        </div>
      </form>

      <h1 style="margin-top: 0px">車流容留上限</h1>
    </div>

    <div class="row row-cols-1 row-cols-md-1 row-cols-lg-1 row-cols-flex g-2">
      <div class="col">
        <div class="card card-clean h-100">
          <div class="bd-example">
            <table id="searchParkingLimitTable" :class="tableStyle">
              <thead class="table-dark">
                <tr>
                  <th scope="col" width="5%">#</th>
                  <th scope="col">時間</th>
                  <th scope="col">風景區</th>
                  <!-- <th scope="col">車種類型</th> -->
                  <th scope="col">警戒狀態</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, key) in dataTableList"
                  :key="key"
                  :class="tableCenterStyle"
                >
                  <td>{{ key + 1 }}</td>
                  <td>{{ getTime(item.startTime) }}</td>
                  <td>{{ item.scenicAreaName }}</td>
                  <!-- <td>{{ getCarType(item.passengerType) }}</td> -->
                  <td>{{ getStatus(item.warningLevel) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import Utils from "../../utils/utils";
import CONST from "../../utils/const";
import exportCSV from "../../utils/exportCSV";
export default {
  name: "Home",
  data() {
    return {
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      table: null,

      startTime: moment().startOf("day").format(),
      endTime: moment().startOf('minute').format(),

      selectScenicAreaId:"",
      selectstatus: ["green", "yellow", "red"], // 配合預設選項為全選
      // selectType:"-1",
      dataTableList: [],
      statusList: [],
      maxSelectTime: Utils.getLastestTime(),
    };
  },
  computed: {
    // ...mapState("scenicArea", { scenicAreaList: "allscenicArea" }),
    ...mapGetters("scenicArea", { scenicAreaList: "getMyScenicArea" }),

    // maxSelectTime() {
    //   return moment().startOf("m").toISOString();
    // },

    carFlowScenicArea() {
      return this.scenicAreaList.filter(s => (s.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.CAR_FLOW))
    },
  },

  methods: {
    async queryCSV() {
     const allDatas = await this.searchParkingData();
      if (Utils.isEmptyObject(allDatas)) {
        return;
      }
      const csvContent = [["時間", "風景區","警戒狀態"]];
      allDatas.forEach((item) => {
        const row = [];
        row.push(this.getTime(item.startTime));
        row.push(item.scenicAreaName);
        // row.push(this.getCarType(item.passengerType));
        row.push(this.getStatus(item.warningLevel));
        csvContent.push(row);
      });

      const fileName = `CSV_${moment(this.startTime).format(
        "YYYY/MM/DD HH:mm"
      )}_車流容留上限.csv`;
      exportCSV.genCSVFile(csvContent, fileName);
    },

    async querySearch() {
       this.dataTableList =await this.searchParkingData();
      this.updateTable();
    },

    async searchParkingData() {
      if (
        Utils.isEmptyObject(this.startTime) ||
        Utils.isEmptyObject(this.endTime)
      ) {
        alert("請選擇起訖時間");
        return;
      }

      if (moment(this.endTime).diff(moment(this.startTime)) < 0) {
        alert("結束時間不可以小於開始時間");
        return;
      }

      
      if(this.selectScenicAreaId ===""){
        alert("請選擇風景區");
        return;
      }
      const condition = {
        warningLevel: this.selectstatus,
        scenicAreaId: this.selectScenicAreaId,
        startTime: moment(this.startTime).startOf('minute').format(),
        endTime: moment(this.endTime).startOf('minute').format(),
        // startTime:"2024-01-26T00:00+08:00",
        // endTime:"2024-01-26T23:59+08:00",
        passengerType:["vehicle"] //僅查詢四輪容留狀態 (小型車+大型車)
      };
      
      
      if(this.selectScenicAreaId === -1){

      const areaId=  this.carFlowScenicArea.map((s) => s.id);
      // console.log("area",areaId)
      condition.scenicAreaId = areaId;
      // console.log("condition.areas",condition.areas);
      }


      // if(condition.passengerType == 1){
      //   //大型車判定=> fullSize + smallBus + truck
      //   condition.passengerType = ["fullSize","smallBus","truck"]
      // }

      await this.$store.dispatch(
        "parkingAvailabilityRate/getParkingAvailabilityRate",
        condition
      );

      const parkingStatusData = await this.$store.getters[
        "parkingAvailabilityRate/getAllParkingAvailabilityRate"
      ];
      
      return parkingStatusData


    },

    getStatus(status) {
      switch (status) {
        case "green":
          return "尚未警戒";

        case "yellow":
          return "警戒 - 已達八成";

        case "red":
          return "警戒 - 已達九成";
      }
    },

    getTime: function (time) {
      if (Utils.isEmptyObject(time)) {
        return "-";
      }
      return moment(time).format("YYYY/MM/DD HH:mm");
    },

    updateMaxSelectTime() {
      this.maxSelectTime = Utils.getLastestTime();// 更新為當前時間
    },

    getCarType(type){
      switch (type) {
        case "compact":
          return "小型車";
        case "fullSize":
          return "大型車(大型巴士)";
        case "smallBus":
          return "大型車(小型巴士)";
        case "truck":
          return "大型車(卡車)";
        case "motorcycle":
          return "機車";
      }
    },

    initTable: function () {
      this.table = $("#searchParkingLimitTable").DataTable({
        aoColumns: [
          ...new Array($("#searchParkingLimitTable th").length - 1),
          {
            bSortable: false,
          },
        ],
        language: {
          url: "/json/dataTableZHTW.json",
        },
        pageLength: 25,
      });
    },

    updateTable() {
      if (!Utils.isEmptyObject(this.table)) {
        this.table.destroy();
      }

      setTimeout(() => {
        this.initTable();
      }, 100);
    },
  },
  mounted() {
    this.statusList = CONST.PARKING_AREA_STATUS;
    this.updateTable();
  },
};
</script>
<style>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}

select:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}

tbody > tr > td, tr > th {
  width: 100%;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
}

/* td自動斷行 */
table {
  table-layout: fixed;
  word-break: break-all;
}

/* table不超過div */
</style>
